<template>
    <div>
        <div class="form-inline">
            <b-col sm="3" class="mx-0 px-0 my-0 py-0">
                <b-input-group v-if="!useTimeInput">
                    <b-form-timepicker
                        :key="aangeraakt"
                        v-model="localSelected.inpekelTijd"
                        @input="set_inputTijd"
                        :disabled="!editAllowed"
                        :class="giveBGclass"
                    />
                    <cheese-tijd
                        v-model="datumtijd"
                        @change="set_inputInpekeltijd"
                        :disabled="!editAllowed"
                    />
                </b-input-group>
                <b-input-group v-if="useTimeInput">
                    <b-form-input
                        v-model="localDate"
                        :type="'date'"
                        @blur="setPekeltijd"
                        :disabled="!editAllowed"
                        :class="giveBGclass"
                    ></b-form-input>
                    <b-form-input
                        v-model="localTijd"
                        :type="'time'"
                        @blur="setPekeltijd"
                        :disabled="!editAllowed"
                        :class="giveBGclass"
                    ></b-form-input>
                </b-input-group>
            </b-col>

            <b-col :sm="setSize" class="mx-0 px-0 my-0 py-0">
                <b-input-group
                    :append="$t('com_st', { ns: 'common' })"
                    :label="$t('com_stuks', { ns: 'common' })"
                >
                    <b-form-input
                        :placeholder="aantKaas"
                        type="number"
                        step="1"
                        v-model.number="localSelected.amount"
                        @change="set_input"
                        :disabled="!editAllowed"
                    ></b-form-input>
                </b-input-group>
            </b-col>

            <b-col v-if="useWeight" sm="2" class="mx-0 px-0 my-0 py-0">
                <b-input-group
                    :append="$t('com_kg', { ns: 'common' })"
                    :label="$t('com_kilos', { ns: 'common' })"
                >
                    <b-form-input
                        :placeholder="weightKaas"
                        type="number"
                        step="0.01"
                        v-model.number="displayKilos"
                        @change="set_input"
                        :disabled="!editAllowed"
                    ></b-form-input>
                </b-input-group>
            </b-col>

            <b-col :sm="setSize" class="mx-0 px-0 my-0 py-0">
                <lookup-combo
                    v-model="localSelected.vormID"
                    v-bind:combotype="lctypeShapes"
                    :disabled="!editAllowed || setDisabledShape"
                    @change="set_input"
                ></lookup-combo>
            </b-col>
            <b-col sm="2" class="mx-0 px-0 my-0 py-0">
                <lookup-combo
                    id="input-kaasalternatief"
                    v-model="localSelected.productID"
                    v-bind:combotype="lctypeCheeseAlternatives"
                    :disabled="setDisabled"
                    v-bind:discrim="maakString(cheeseProductID)"
                    @change="set_input"
                ></lookup-combo>
            </b-col>

            <b-col sm="1" class="mx-0 px-0 my-0 py-0">
                <b-dropdown
                    id="dropdown-form"
                    text="..."
                    ref="dropdown"
                    menu-class="w-100"
                    class="w-100"
                    boundary="viewport"
                >
                    <div class="fluid-container">
                        <b-dropdown-form>
                            <div>
                                <b-form-group
                                    :label="
                                        $t('prod_plaats', { ns: 'production' })
                                    "
                                    label-for="dropdown-form-correct"
                                    @submit.stop.prevent
                                >
                                    <b-input-group
                                        :label="
                                            $t('com_location', { ns: 'common' })
                                        "
                                    >
                                        <lookup-combo
                                            v-model="localSelected.badID"
                                            v-bind:combotype="lctypeLocation"
                                            v-bind:discrim="pekelbad"
                                            @change="set_input"
                                            :disabled="!editAllowed"
                                        ></lookup-combo>
                                    </b-input-group>
                                    <b-input-group
                                        :append="
                                            $t('prod_kooi', {
                                                ns: 'production'
                                            })
                                        "
                                        :label="
                                            $t('prod_kooi', {
                                                ns: 'production'
                                            })
                                        "
                                    >
                                        <b-form-input
                                            v-model="localSelected.kooi"
                                            @change="set_input"
                                            :disabled="!editAllowed"
                                        ></b-form-input>
                                    </b-input-group>
                                    <b-input-group
                                        :append="
                                            $t('prod_laag', {
                                                ns: 'production'
                                            })
                                        "
                                        :label="
                                            $t('prod_laag', {
                                                ns: 'production'
                                            })
                                        "
                                    >
                                        <b-form-input
                                            v-model="localSelected.laag"
                                            @change="set_input"
                                            :disabled="!editAllowed"
                                        ></b-form-input>
                                    </b-input-group>
                                    <b-dropdown-divider></b-dropdown-divider>
                                    <b-input-group>
                                        <b-form-input
                                            v-model="opmerking"
                                            :placeholder="opmerkingplaceholder"
                                        ></b-form-input>
                                        <b-button
                                            class="float-right"
                                            variant="primary"
                                            @click="saveRemark()"
                                            >Ok</b-button
                                        >
                                    </b-input-group>
                                </b-form-group>
                            </div>
                            <b-dropdown-divider></b-dropdown-divider>
                        </b-dropdown-form>
                    </div>
                </b-dropdown>
            </b-col>
        </div>
    </div>
</template>
<script>
import { InpekelItem } from '../../models/BakInfo_helper';
import { LookupCombo } from './index';
import CheeseTijd from './CheeseTijd';
import DateHelper from '../../models/DateHelper';
import Helper from '../../models/Helper';
import { Feature } from '../../models/Features';

export default {
    name: 'InpekelItemCombo',
    data: function () {
        return {
            lctypeCheeseAlternatives: window.constants.LCCHEESEALTERNATIVES,
            lctypeShapes: window.constants.LCSHAPES,
            lctypeLocation: window.constants.LCLOCATION,
            pekelbad: window.constants.BRINESTOCKLOCATION.toString(), // moet string zijn, 5 is pekelbad
            errorMessage: '',
            eenheidID: null,
            flexList: [],
            aangeraakt: 1,
            datumtijd: null,
            localDate: null,
            localTijd: null,
            opmerking: null,
            opmerkingplaceholder:
                this.$t('com_add', { ns: 'common' }) +
                ' ' +
                this.$t('com_opmerking', { ns: 'common' }).toLowerCase()
        };
    },
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        selected: {
            type: InpekelItem,
            required: true
        },
        editAllowed: {
            type: Boolean,
            default: false
        },
        cheeseProductID: {
            type: Number,
            required: false
        },
        refresh: {
            type: Number,
            required: false
        },
        baseDateTime: {
            type: String
        },
        timeInput: {
            type: Boolean,
            default: false
        },
        zuurselTijd: {
            type: String,
            default: null
        }
    },
    watch: {
        refresh() {
            this.forceRefesh();
        }
    },
    components: {
        LookupCombo,
        CheeseTijd
    },
    computed: {
        useTimeInput() {
            if (this.timeInput) {
                return false;
            }
            return !this.checkFeature('conf_UseDateTimePicker');
        },
        aantKaas() {
            return Helper.stringformat(
                '{0} {1}',
                this.$t('com_number', { ns: 'common' }),
                this.$t('com_kazen', { ns: 'common' }).toLowerCase()
            );
        },
        weightKaas() {
            return Helper.stringformat(
                '{0} {1}',
                this.$t('com_weight', { ns: 'common' }),
                this.$t('com_kazen', { ns: 'common' }).toLowerCase()
            );
        },
        localSelected() {
            return this.selected;
        },
        displayKilos: {
            get() {
                const kilos = this.localSelected.kilos;
                return typeof kilos === 'number' ? kilos.toFixed(2) : kilos;
            },
            set(value) {
                this.localSelected.kilos = value;
            }
        },
        useWeight() {
            return this.checkFeature('conf_UseCheeseWeights');
        },
        setSize() {
            return this.useWeight ? 2 : 3;
        },
        setDisabled() {
            return this.localSelected.wijzigbaar || !this.editAllowed;
        },
        giveBGclass() {
            return this.localSelected.inpekelTijdOri != undefined
                ? 'bg-green'
                : ' bg-blue';
        },
        setDisabledShape() {
            const disableMultipleProductShapes = this.checkFeature(
                'conf_disableMultipleProductShapes'
            );
            return disableMultipleProductShapes;
        }
    },
    methods: {
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        },
        maakString(item) {
            return String(item);
        },
        isValid() {
            const result =
                this.localSelected.amount > 0 && this.localSelected.vormID > 0;
            return result;
        },
        set_input() {
            this.localSelected.isChanged = true;
            this.$emit('validComponent', this.isValid());
            this.$emit('change', true);
            this.$emit('input', this.localSelected);
        },
        set_inputTijd(value) {
            const tijd = this.determineDate();
            this.localSelected.inpekelTijd = DateHelper.convertedFromTimepicker(
                tijd,
                value
            );
            this.localSelected.inpekelTijdOri = this.localSelected.inpekelTijd;
            this.set_input();
        },
        set_inputInpekeltijd(value) {
            if (DateHelper.dateIsValid(value)) {
                this.localSelected.inpekelTijdOri = value;
                this.localSelected.inpekelTijd =
                    DateHelper.convertedToDateTimeString(value);
                this.aangeraakt += 1;
                this.set_input();
            }
        },
        setPekeltijd() {
            if (this.localDate && this.localTijd) {
                const dateTime = DateHelper.DateFromInput(
                    this.localDate,
                    this.localTijd
                );
                this.localSelected.inpekelTijdOri = dateTime;
                this.localSelected.inpekelTijd =
                    DateHelper.convertedToDateTimeString(dateTime);
                this.aangeraakt += 1;
                this.set_input();
            }
        },
        forceRefesh() {
            this.localSelected.inpekelTijdOri = this.selected.inpekelTijdOri;
            this.localSelected.inpekelTijd =
                DateHelper.convertedToDateTimeString(this.selected.inpekelTijd);
            this.setTijd();
            this.$forceUpdate();
        },
        determineDate() {
            // als ori bestaat, gebruik die
            if (this.localSelected.inpekelTijdOri) {
                return this.localSelected.inpekelTijdOri;
            }
            const nu = DateHelper.localLuxonDate();
            const baseDate = this.baseDateTime
                ? DateHelper.MakeDateTime(this.baseDateTime)
                : nu;
            //bij basedate moet het tijdselement van nu toegvevoegd worden
            const baseDatumTijd = DateHelper.DateFromInput(baseDate, nu);
            // als zuurselTijd bestaat en zuurseltijd - nu > 24 uur, gebruik basedate
            if (this.zuurselTijd) {
                const zuurselDate = DateHelper.MakeDateTime(this.zuurselTijd);
                if (
                    Math.abs(DateHelper.dateDiffinHours(zuurselDate, nu)) > 24
                ) {
                    return baseDatumTijd;
                }
            } else {
                // geen zuurselTijd, als basedate - nu > 24 uur, gebruik basedate
                if (
                    Math.abs(DateHelper.dateDiffinHours(baseDatumTijd, nu)) > 24
                ) {
                    return baseDatumTijd;
                }
            }
            return new Date();
        },
        setTijd() {
            this.datumtijd = this.determineDate();
            const localDateTime = new Date(this.datumtijd);
            this.localDate = DateHelper.DateForInput(
                localDateTime,
                true,
                false
            );
            this.localTijd = DateHelper.DateForInput(
                localDateTime,
                false,
                true
            );
        },
        saveRemark() {
            //{bad.kooi.laag.aantal}
            // split op .
            // zijn er 4 delen, dan is het een remark voor een alternatieve kooi / laag
            const remarkParts = this.opmerking.split('.');
            if (remarkParts.length === 4) {
                this.localSelected.specialOpmerking = this.opmerking;
                this.localSelected.predefinedRemark = this.opmerking;
            } else {
                this.localSelected.opmerking = this.opmerking;
            }
            this.set_input();
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return this.$root.handleRight(id);
        }
    },
    mounted() {
        this.setTijd();
    },
    created() {}
};
</script>

<style scoped>
.bg-green {
    background-color: #c1e881 !important;
}
.bg-blue {
    background-color: hwb(203 55% 7%) !important;
}
.fontcolor {
    color: red;
}
</style>
